import { Button } from '@picsart/design-system/components/Button';
import { useTranslator } from '@picsart/rc/services/localization';

import { useAppStore, type IAppStore } from '@/store';
import useAuth from '@/hooks/useAuth';
import useStyles from './styles';
import useGenerateAction from '@/hooks/useGenerateAction';
import isFormValid from '@/utils/isFormValid';

const selector = (store: IAppStore) => ({
  credits: store.credits,
  isCreditsLoading: store.isCreditsLoading,
  isPresetLoading: store.isPresetLoading,
  inputs: store.inputs,
});

/**
 * The Generate button + credits/terms footer. Owns every concern the
 * button needs via useGenerateAction (auth gate, credits gate, navigation,
 * generation). No props.
 */
const CreateFooter = () => {
  const classes = useStyles();
  const translate = useTranslator();

  const { isAuthorized, isResolved } = useAuth();
  const { isCreditsLoading, isPresetLoading, inputs } = useAppStore(selector);
  const { isSubmitting, handleGenerate } = useGenerateAction();

  const formIsValid = isFormValid(inputs);

  const showSignIn = isResolved && !isAuthorized;
  const canClickButton =
    showSignIn || (formIsValid && !isPresetLoading && !isCreditsLoading);

  // const renderCredits = () => {
  //   if (isCreditsLoading) {
  //     return <Spinner size="xsmall" className={classes.creditsSpinner} />;
  //   }
  //   if (credits !== null && credits > 0) {
  //     return (
  //       <>
  //         <IconGenAI fill="currentColor" className={classes.sparklesIcon} />
  //         {credits}
  //       </>
  //     );
  //   }
  //   return null;
  // };

  return (
    <div className={classes.footer}>
      <Button
        dataTestId="genai-generate-button"
        skin="primary"
        variant="filled"
        size="large"
        isFullWidth
        onClick={handleGenerate}
        isLoading={isSubmitting}
        isDisabled={!canClickButton || isSubmitting}
        className={classes.generateButton}
      >
        {translate(showSignIn ? 'Sign in to generate' : 'Generate')}
      </Button>
      <p className={classes.termsText}>
        {translate('By generating, you agree to our')}{' '}
        <a
          href="https://picsart.com/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.termsLink}
        >
          {translate('Terms')}
        </a>{' '}
        {translate('and')}{' '}
        <a
          href="https://picsart.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className={classes.termsLink}
        >
          {translate('Privacy Policy')}
        </a>
      </p>
    </div>
  );
};

export default CreateFooter;
